import { ProtobufClient } from 'api/protobuf/protobuf-client';
import { goBackendApi } from 'hooks/api/httpApi';
import { LabelCountResponseSchema } from '../../../../../../../../pb/responses/v1/label_count_response_pb';

export const getLabelCount = async (from: string, to: string) => {
    const pbClient = new ProtobufClient(goBackendApi());
    return pbClient.getRequest(LabelCountResponseSchema, '/api/v1/label/count', { from, to });
};
